import nfetch from "@/utils/events/nfetch";

import PosologiaModel from "../models/posologiaModel";

import { IService } from "./base/iService";

class PosologiaService extends IService<PosologiaModel> {
    protected cachedPosologiaPadrao: { [franquiaId: number]: number } = {};

    constructor() {
        super("Posologia");
    }

    public async getPosologiaPadrao(franquiaId: number) {
        if (this.cachedPosologiaPadrao[franquiaId] || this.cachedPosologiaPadrao[franquiaId] == 0) {
            return this.cachedPosologiaPadrao[franquiaId];
        }

        const id = await nfetch(`/${this.controllerName}/GetPosologiaPadrao?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<Promise<number>>();

        this.cachedPosologiaPadrao[franquiaId] = id;
        return id;
    }

    public getFromSearchComboById(id: number, franquiaId?: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromSearchComboById?id=${id}&franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        });
    }

    public getFromSearchComboByText(filterKey = ""): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromSearchComboByText?filterKey=${filterKey}`, {
            credentials: "same-origin",
        });
    }
}

export default new PosologiaService();
